export default __webpack_public_path__ + "static/media/zero_sac_cabas_2.3df675a5.png";